/**
 * Tenants where Productivity must be hidden (contract / customer requirement).
 * Match on `user.primaryDomain` (lowercased).
 */
const PRODUCTIVITY_DISABLED_PRIMARY_DOMAINS = new Set(['synthesia.io'])

export const isProductivityDisabledForPrimaryDomain = (
  primaryDomain: string | undefined,
): boolean =>
  PRODUCTIVITY_DISABLED_PRIMARY_DOMAINS.has((primaryDomain ?? '').toLowerCase())
